import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { loadCalendlyScript } from './utils/calendly';
// Lazy load legal pages (not critical for initial load)
const ImpressumPage = lazy(() => import('./pages/ImpressumPage').then(module => ({
  default: module.ImpressumPage
})));
const DatenschutzPage = lazy(() => import('./pages/DatenschutzPage').then(module => ({
  default: module.DatenschutzPage
})));
// Loading fallback component
function PageLoader() {
  return <div className="min-h-screen flex items-center justify-center bg-[#0A0E27]" data-id="element-0">
      <div className="text-white text-lg" data-id="element-1">Lädt...</div>
    </div>;
}
export function App() {
  // Load Calendly script on mount
  useEffect(() => {
    loadCalendlyScript();
  }, []);
  return <HelmetProvider data-id="element-2">
      <BrowserRouter data-id="element-3">
        <ScrollToTop data-id="element-4" />
        <Layout data-id="element-5">
          <Suspense fallback={<PageLoader data-id="element-7" />} data-id="element-6">
            <Routes data-id="element-8">
              <Route path="/" element={<HomePage data-id="element-10" />} data-id="element-9" />
              <Route path="/impressum" element={<ImpressumPage data-id="element-12" />} data-id="element-11" />
              <Route path="/datenschutz" element={<DatenschutzPage data-id="element-14" />} data-id="element-13" />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>;
}